import { render, staticRenderFns } from "./WillBeneficiariesIllnessWorkingYN.vue?vue&type=template&id=f4d7ba70"
import script from "./WillBeneficiariesIllnessWorkingYN.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesIllnessWorkingYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports